import React from 'react';
import PropTypes from 'prop-types';

var NotificationInfoRight = function NotificationInfoRight(_ref) {
  var text = _ref.text;
  return React.createElement(
    'span',
    { className: 'time' },
    text
  );
};

NotificationInfoRight.propTypes = {
  /** Text */
  text: PropTypes.string.isRequired
};

export default NotificationInfoRight;


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Notification/NotificationInfoRight.js
// module id = 302
// module chunks = 0